import { bindActionCreators } from 'redux';
import { find, forEach, head, includes, isNil, map, split } from 'lodash/fp';
import { Toast } from '@ahmdigital/ui';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

import selectToast from '../../../selectors/select-toast';
import ToastActions from '../../../actions/toast';
import toastData from './toast-data';

const TOAST_DELAY_TIME = 1500;

const Toaster = () => {
  const dispatch = useDispatch();
  const toastActions = bindActionCreators(ToastActions, dispatch);
  const toasts = useSelector(selectToast) ?? [];
  const { asPath } = useRouter();
  const path = head(split('?', asPath));

  useEffect(() => {
    forEach((toast) => {
      toastActions.setToastContent(toast);
      toastActions.openToast(toast.id);
    }, toastData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {map((toast) => {
        const config = find({ id: toast.id }, toastData);
        return (
          !isNil(toast) &&
          includes(path, config?.whitelist) && (
            <Toast
              content={toast.content}
              delayTime={TOAST_DELAY_TIME}
              key={toast.id}
              isOpen={toast.isOpen}
              onClose={() => toastActions.closeToast(toast.id)}
            />
          )
        );
      }, toasts)}
    </>
  );
};

export default Toaster;
